import { createFileRoute } from "@tanstack/react-router";
import Review from "@/components/_Review";

export const Route = createFileRoute("/_auth/docs_/$documentId/review")({
  component: Review,
});
